import { Component, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-sales-mobile-app",
  templateUrl: "./sales-mobile-app.component.html",
  styleUrls: ["./sales-mobile-app.component.scss"],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule],
})
export class SalesMobileAppComponent {
  versionNumber = "1.0.1";
  isoBlobUrl = `itms-services://?action=download-manifest&url=${environment.msal.redirectUri}/assets/salesApp/iOS/${environment.envName}/manifest.plist`;
  androidBlobUrl = `${environment.msal.redirectUri}/assets/salesApp/Android/${environment.envName}/app-armeabi-v7a-release.apk`;
  constructor(private router: Router) {}

  downloadAndNavigate(modeIOS: boolean) {
    if (modeIOS) {
      window.location.href = this.isoBlobUrl;
      this.router.navigate(["sales-mobile-app/ios-instruction"]);
    } else {
      window.location.href = this.androidBlobUrl;
      this.router.navigate(["sales-mobile-app/android-instruction"]);
    }
  }
}
